// France
export const locale = {
	lang: "fr",
	data: {
		TRANSLATOR: {
			SELECT: "choisissez votre langue"
		},
		MENU: {
			NEW: "Nouveau",
			ACTIONS: "Actes",
			CREATE_POST: "Créer un nouveau Post",
			REPORTS: "Rappots",
			APPS: "Applications",
			DASHBOARD: "Tableau de Bord"
		},
		UEX: {
			POLICY: {
				LIST: "Policy list",
				ADD: "New policy"
			},
			COMPANY: {
				LIST: "Company list",
				ADD: "New company"
			},
			MOVEMENT: {
				LIST: "Movement list",
				ADD: "New movement"
			},
			SUB_MOVEMENT: {
				LIST: "Staff movement list",
				ADD: "New staff movement"
			},
			INSURED: {
				LIST: "Insured list",
				ADD: "New insured"
			}
		},
		AUTH: {
			GENERAL: {
				OR: "Ou",
				SUBMIT_BUTTON: "Soumettre",
				NO_ACCOUNT: "Ne pas avoir de compte?",
				SIGNUP_BUTTON: "Registre",
				FORGOT_BUTTON: "Mot de passe oublié",
				BACK_BUTTON: "Back",
				PRIVACY: "Privacy",
				LEGAL: "Legal",
				CONTACT: "Contact"
			},
			LOGIN: {
				TITLE: "Créer un compte",
				BUTTON: "Sign In"
			},
			FORGOT: {
				TITLE: "Forgotten Password?",
				DESC: "Enter your email to reset your password"
			},
			REGISTER: {
				TITLE: "Sign Up",
				DESC: "Enter your details to create your account"
			},
			INPUT: {
				EMAIL: "Email",
				FULLNAME: "Fullname",
				PASSWORD: "Mot de passe",
				CONFIRM_PASSWORD: "Confirm Password"
			},
			VALIDATION: {
				INVALID: "{{name}} n'est pas valide",
				REQUIRED: "{{name}} est requis",
				MIN_LENGTH: "{{name}} minimum length is {{min}}"
			}
		},
		COMPANY: {
			COMPANY_LIST: "Company list"
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: "Nombre d'enregistrements sélectionnés:"
			},
			ECOMMERCE: "éCommerce",
			CUSTOMERS: {
				CUSTOMERS: "Les clients",
				CUSTOMERS_LIST: "Liste des clients",
				NEW_CUSTOMER: "Nouveau client",
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: "Suppression du client",
					DESCRIPTION:
						"Êtes-vous sûr de supprimer définitivement ce client?",
					WAIT_DESCRIPTION: "Le client est en train de supprimer ...",
					MESSAGE: "Le client a été supprimé"
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: "Supprimer les clients",
					DESCRIPTION:
						"Êtes-vous sûr de supprimer définitivement les clients sélectionnés?",
					WAIT_DESCRIPTION: "Les clients suppriment ...",
					MESSAGE: "Les clients sélectionnés ont été supprimés"
				},
				UPDATE_STATUS: {
					TITLE:
						"Le statut a été mis à jour pour les clients sélectionnés",
					MESSAGE:
						"Le statut des clients sélectionnés a été mis à jour avec succès"
				},
				EDIT: {
					UPDATE_MESSAGE: "Le client a été mis à jour",
					ADD_MESSAGE: "Le client a été créé"
				}
			}
		},
		GLOBAL: {
			COMPANY: {
				LIST: "Company List",
				NEW_COMPANY: "New Company"
			},
			POLICY: {
				LIST: "Policy List"
			},
			INSURED: {
				LIST: "Insured List"
			}
			
		}
	}
};
